'use client';
import { createContext } from 'react';
import { useNonNullishContext } from '../../hooks/use-non-nullish-context.js';

const AdaptiveCarouselContext = createContext(void 0);
function useAdaptiveCarouselContext() {
    return useNonNullishContext(AdaptiveCarouselContext);
}

export { AdaptiveCarouselContext, useAdaptiveCarouselContext };
